export default function MasterCardLogo() {
  return (
    <svg
      width="26"
      height="16"
      viewBox="0 0 26 16"
      fill="none"
      className="master-card-logo"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5075 1.7113H9.47144V14.2886H16.5075V1.7113Z"
        fill="#FF5A00"
      />
      <path
        d="M9.93995 8C9.93995 5.44466 11.1473 3.1767 13 1.71133C11.6365 0.64466 9.91653 0 8.04043 0C3.59608 0 0 3.57799 0 8C0 12.422 3.59608 16 8.04043 16C9.91653 16 11.6365 15.3553 13 14.2887C11.1447 12.844 9.93995 10.5553 9.93995 8Z"
        fill="#EB001B"
      />
      <path
        d="M26 8C26 12.422 22.4039 16 17.9596 16C16.0835 16 14.3635 15.3553 13 14.2887C14.8761 12.8207 16.06 10.5553 16.06 8C16.06 5.44466 14.8527 3.1767 13 1.71133C14.3609 0.64466 16.0809 0 17.957 0C22.4039 0 26 3.60129 26 8Z"
        fill="#F79E1B"
      />
    </svg>
  );
}
